import { Button, Input } from '@repo/ui';
import type { ReactElement } from 'react';

interface InlineRenameFormProps {
  /** 입력의 접근성 라벨 — 관례상 `${기존 이름} 새 이름`. */
  readonly ariaLabel: string;
  readonly name: string;
  /** 입력 상한 — 계약 이름 스키마의 max 와 같게 준다. 넘친 값은 서버가 영어 검증 문구로 거부한다. */
  readonly maxLength?: number;
  readonly isPending: boolean;
  readonly onNameChange: (name: string) => void;
  readonly onSubmit: () => void;
  readonly onCancel: () => void;
}

/** 행 안에서 이름을 고치는 인라인 폼 — 카테고리·인쇄 방식·폰트·잉크 색상이 공유한다. */
export const InlineRenameForm = ({
  ariaLabel,
  name,
  maxLength,
  isPending,
  onNameChange,
  onSubmit,
  onCancel,
}: InlineRenameFormProps): ReactElement => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
    className="flex items-center gap-1.5"
  >
    <Input
      aria-label={ariaLabel}
      className="h-8 w-40"
      value={name}
      maxLength={maxLength}
      onChange={(event) => onNameChange(event.target.value)}
      autoFocus
    />
    <Button type="submit" size="sm" isLoading={isPending}>
      저장
    </Button>
    <Button type="button" variant="ghost" size="sm" onClick={onCancel}>
      취소
    </Button>
  </form>
);
